import { m } from 'framer-motion';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Card, Container, Grid, Hidden, Typography } from '@mui/material';
// components
import { MotionViewport, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const DISADVANTAGES = [
  {
    description:
      'Zu Stoßzeiten geht es in der Bäckerei hektisch zu und Kunden warten in langen Schlangen vor der Bäckerei.',
  },
  {
    description:
      'Das Bestellen, Einpacken und Bezahlen der Waren in der Bäckerei ist nicht nur Zeitaufwändig, sondern fordert mehr Personal.',
  },
  {
    description:
      'Die schwankende Nachfrage führt zur schwierigen Prognosen der benötigten Warenmenge, Folgen sind Verluste durch nicht verkaufte Backwaren.',
  },
];

const shadowIcon = (color: string) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(15),
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(15),
  },
}));

const IconStyle = styled('img')(() => ({
  height: 'auto',
  filter: shadowIcon('#707070'),
}));

// ----------------------------------------------------------------------

export default function HomeBakerBenefits() {
  return (
    <RootStyle>
      <Container component={MotionViewport} maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            mb: 10,
          }}
        >
          <m.div variants={varFade().inUp}>
            <Typography component="div" variant="overline" sx={{ mb: 2, color: 'text.disabled' }}>
            Onlineshop
            </Typography>
          </m.div>
          <m.div variants={varFade().inDown}>
            <Typography variant="h2">Ohne Shop</Typography>
          </m.div>
        </Box>

        <Grid container spacing={3} sx={{ px: 5 }}>
          <Grid
            item
            xs={12}
            md={10}
            sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
          >
            {DISADVANTAGES.map((disadvantage, index) => (
              <Box key={index} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ...(index !== 2 && { mb: 3 }) }}>
                <m.div variants={varFade().inLeft}>
                  <Typography sx={{ color: 'text.secondary' }}>
                    {disadvantage.description}
                  </Typography>
                </m.div>
              </Box>
            ))}
          </Grid>
          
          <Grid item md={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden mdDown>
              <IconStyle
                src="static/home/waste.webp"
                alt=""
              />
            </Hidden>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
